import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class KeyValueGeneratorService {
  /**
   * Return an array with key & values
   * Returns null if array keys & values not equal
   * Return an array with key & values if keys or values is null
   * @param array The array to manipulate
   * @param key The items of the array that should be the keys
   * @param value The items of the values that should be the values
   */
  public generate(array: any[], key?: string, value?: string) {
    if (array === undefined || !Array.isArray(array)) {
      return;
    }

    if (!key || !value) {
      array = array.map((item) => {
        return { key: item, value: item };
      });
    } else {
      const keys = array.map((item) => item[key]);
      const values = array.map((item) => item[value]);

      if (keys.length !== values.length) {
        return;
      }

      array = keys.map((id, index) => {
        return { key: id, value: values[index] };
      });
    }

    return array;
  }
}
